import { MergeFlowModalContent } from "./MergeFlow/MergeFlowModalContent";
import { NewPaymentModalContent } from "./NewPaymentModalContent";
import { SearchFlowContext, useSearchFlowContext } from "./SearchFlow/useSearchFlow";
import { SearchFlowContextProvider } from "./SearchFlow/SearchFlowContextProvider";
import { create } from "@ebay/nice-modal-react";

/**
 * Modal for creating a new payment request. This includes creating new users if necessary.
 * Also, in PMS-integrated sessions, provides the ability to merge an unlinked P/RP with a PMS patient.
 * Note that this is *not* take-a-payment.
 *
 * NiceModal renders these in the larger DOM scope, which allows them to be open/closed from anywhere within the app.
 * This also decouples the Modal from the calling control, which means React Context cannot be used.
 */
export const NewPaymentModal = create(() => {
    // note that when existingPrp.id is not defined, existingPrp represents a VyneSync patient (and not an actual P/RP)
    return (
        <SearchFlowContextProvider>
            <SearchFlowContext.Consumer>
                {() => {
                    const { merging } = useSearchFlowContext();
                    return merging ? <MergeFlowModalContent /> : <NewPaymentModalContent />;
                }}
            </SearchFlowContext.Consumer>
        </SearchFlowContextProvider>
    );
});
